import { Controller } from "@hotwired/stimulus"

// Members' profiles, one popup each, opened from any face or name on the
// page: data-action="profiles#open" data-profiles-name-param="Ann". Closes
// with its button, Esc or a click on the backdrop. A refresh while one is
// open keeps it open: the server renders them closed, so the morph is
// refused that one change, as in dialog_controller.js.
export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    this.hold = this.hold.bind(this)
    this.element.addEventListener("turbo:before-morph-attribute", this.hold)
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-morph-attribute", this.hold)
  }

  open(event) {
    event.preventDefault()
    const dialog = this.dialogTargets.find(d => d.dataset.name === event.params.name)
    if (dialog) dialog.showModal()
  }

  close(event) {
    event.target.closest("dialog").close()
  }

  backdrop(event) {
    if (event.target.tagName === "DIALOG") event.target.close()
  }

  hold(event) {
    if (this.dialogTargets.includes(event.target) && event.detail.attributeName === "open") event.preventDefault()
  }
}
